import styleInject from 'style-inject';

var css_248z = ".TableRow-module_linkRow__ZcE4X{color:var(--color-text);cursor:pointer}.TableRow-module_linkRow__ZcE4X:hover{color:var(--color-link)}.TableRow-module_row__ovIa8{display:contents}";
var styles = {"linkRow":"TableRow-module_linkRow__ZcE4X","row":"TableRow-module_row__ovIa8"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFibGVSb3cubW9kdWxlLnNjc3MuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OzsifQ==
